import {Routes} from './routes';
import './App.scss';
import { StoreContextProvider } from './store/context';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useEffect } from 'react';
import CacheBuster from 'react-cache-buster';
import pkg from '../package.json'; 

import LoadingSpinner from './shared/loading/loading';
const App = () => {
  useEffect(()=>{
    if(!window.location.host.includes('fs2c') && !window.location.host.includes('localhost')){
      const substring = `${process.env.REACT_APP_REDIRECT_URI}`.substring(0, `${process.env.REACT_APP_REDIRECT_URI}`.length - 4) + 'ui';
      window.location.assign(substring)
    }
  });
  return (
    <CacheBuster
      currentVersion={pkg.version}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      loadingComponent={<LoadingSpinner />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
    >
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <StoreContextProvider>
        <Routes/>
      </StoreContextProvider>
    </LocalizationProvider>
    </CacheBuster>
  )
}

export default App